import React from 'react';
import About from './page/about';
import Home from './page/home';
import Graph from "./page/graph"
import { Routes, Route, Router } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { extendTheme, ChakraProvider } from '@chakra-ui/react'

const colors = {
  brand: {
    900: '#1a365d',
    800: '#153e75',
    700: '#2a69ac',
  },
}
const theme = extendTheme({ colors })

function App() {
  return (
    <ChakraProvider theme={theme}>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={true}
      />
      <Routes>
        <Route path="/" element={<Graph />} />
        {/* <Route path="/about" element={<About/>} /> */}
        {/* <Route path="/graph" element={<Graph/>} /> */}
      </Routes>
    </ChakraProvider>


  );
}

export default App;
